import { Box } from "@chakra-ui/react";

import type { IIframe } from "../../../../../utils/types";

import styles from "./GuideContentBody.module.scss";

interface IframeContentProps {
  field: IIframe;
}

export default function IframeContent({ field }: IframeContentProps) {
  return (
    <Box
      {...(field.styles?.container ?? {})}
      className={styles.iframeContainer}
    >
      <iframe
        title={field.title}
        width={field.styles.iframe.width}
        height={field.styles.iframe.height}
        src={field.src}
        allowFullScreen
      />
    </Box>
  );
}
